import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from 'abs-ngx-library/src/lib/loyalty-card';
import { LoyaltyCardModule } from 'abs-ngx-library/src/lib/loyalty-card';
import * as i3 from 'abs-ngx-library/src/lib/loyalty-non-digital-coupon-card';
import { LoyaltyNonDigitalCouponCardModule } from 'abs-ngx-library/src/lib/loyalty-non-digital-coupon-card';

function DealsGridAlV1Component_div_0_loyalty_card_al_v1_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "loyalty-card-al-v1", 4);
    i0.ɵɵlistener("couponToFocusOn", function DealsGridAlV1Component_div_0_loyalty_card_al_v1_1_Template_loyalty_card_al_v1_couponToFocusOn_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.getFocusOn($event)); })("openRightFlyoutEvent", function DealsGridAlV1Component_div_0_loyalty_card_al_v1_1_Template_loyalty_card_al_v1_openRightFlyoutEvent_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onClickEvent($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const coupon_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("col-12 col-sm-12 col-md-6 col-lg-", 12 / (ctx_r1.gridSettings == null ? null : ctx_r1.gridSettings.numberOfColumns), " coupon-grid-offer");
    i0.ɵɵproperty("cardType", "coupon")("couponDisplayFormat", "grid")("cardData", coupon_r3)("cardIndex", i_r4)("logoProps", ctx_r1.logoProps)("configObj", ctx_r1.configObj);
} }
function DealsGridAlV1Component_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, DealsGridAlV1Component_div_0_loyalty_card_al_v1_1_Template, 1, 9, "loyalty-card-al-v1", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.updatedGridData);
} }
function DealsGridAlV1Component_div_1_loyalty_non_digital_coupon_card_al_v1_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "loyalty-non-digital-coupon-card-al-v1", 6);
    i0.ɵɵlistener("openFlyOutEvent", function DealsGridAlV1Component_div_1_loyalty_non_digital_coupon_card_al_v1_1_Template_loyalty_non_digital_coupon_card_al_v1_openFlyOutEvent_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onClickEvent($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const coupon_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cmsCardData", coupon_r6)("cardIndex", i_r7)("myListItems", ctx_r1.myListItems);
} }
function DealsGridAlV1Component_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, DealsGridAlV1Component_div_1_loyalty_non_digital_coupon_card_al_v1_1_Template, 1, 3, "loyalty-non-digital-coupon-card-al-v1", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.updatedGridData);
} }
function DealsGridAlV1Component_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 8);
    i0.ɵɵlistener("click", function DealsGridAlV1Component_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.loadMoreCoupons()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.gridSettings == null ? null : ctx_r1.gridSettings.buttonText);
} }
class DealsGridAlV1Component {
    constructor() {
        this.calledBy = '';
        this.myListItems = [];
        this.configObj = {
            appName: '',
            programType: ''
        };
        this.openFlyOutEvent = new EventEmitter();
        this.onClickOfLoadMoreEvent = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        let changedGridData = changes['gridData'];
        if (changedGridData && changedGridData.currentValue !== changedGridData.previousValue) {
            const gridData_copy = [...this.gridData];
            this.updatedGridData = this.gridSettings.areDigitalCoupons ? gridData_copy.splice(0, 30) : gridData_copy;
            if (window['AB'] && window['AB']['DATALAYER'] && this.gridData && Array.isArray(this.gridData) && this.gridData.length > 0) {
                window['AB']['DATALAYER'].sendCouponImpressions(this.gridData, undefined, undefined, true);
            }
        }
    }
    getFocusOn(e) {
        console.warn(e);
    }
    loadMoreCoupons() {
        if (this.gridSettings.hasNextPageToken) {
            this.onClickOfLoadMoreEvent.emit();
        }
        else {
            const gridData_copy = [...this.gridData];
            const newSet = gridData_copy.splice(this.updatedGridData.length, 30);
            this.updatedGridData = [...this.updatedGridData, ...newSet];
        }
    }
    onClickEvent(couponData) {
        console.warn(couponData);
        this.openFlyOutEvent.emit(couponData);
    }
    static { this.ɵfac = function DealsGridAlV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DealsGridAlV1Component)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DealsGridAlV1Component, selectors: [["deals-grid-al-v1"]], inputs: { gridSettings: "gridSettings", gridData: "gridData", calledBy: "calledBy", logoProps: "logoProps", myListItems: "myListItems", configObj: "configObj" }, outputs: { openFlyOutEvent: "openFlyOutEvent", onClickOfLoadMoreEvent: "onClickOfLoadMoreEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [["class", "row", 4, "ngIf"], ["class", "mt-3 d-flex justify-content-center", 4, "ngIf"], [1, "row"], [3, "cardType", "couponDisplayFormat", "cardData", "cardIndex", "class", "logoProps", "configObj", "couponToFocusOn", "openRightFlyoutEvent", 4, "ngFor", "ngForOf"], [3, "couponToFocusOn", "openRightFlyoutEvent", "cardType", "couponDisplayFormat", "cardData", "cardIndex", "logoProps", "configObj"], ["class", "col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 pr-0 my-2", 3, "cmsCardData", "cardIndex", "myListItems", "openFlyOutEvent", 4, "ngFor", "ngForOf"], [1, "col-sm-12", "col-md-6", "col-lg-4", "col-xl-3", "col-xxl-3", "pr-0", "my-2", 3, "openFlyOutEvent", "cmsCardData", "cardIndex", "myListItems"], [1, "mt-3", "d-flex", "justify-content-center"], ["aria-label", "Load More button", "tabindex", "0", "role", "button", 1, "btn", "btn-xl", "btn-primary", 3, "click"]], template: function DealsGridAlV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DealsGridAlV1Component_div_0_Template, 2, 1, "div", 0)(1, DealsGridAlV1Component_div_1_Template, 2, 1, "div", 0)(2, DealsGridAlV1Component_div_2_Template, 3, 1, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.gridSettings.areDigitalCoupons);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.gridSettings.areDigitalCoupons);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.updatedGridData && ctx.gridData && ctx.updatedGridData.length < (ctx.gridData == null ? null : ctx.gridData.length) || (ctx.gridSettings == null ? null : ctx.gridSettings.hasNextPageToken));
        } }, dependencies: [i1.NgForOf, i1.NgIf, i2.LoyaltyCardAlV1Component, i3.LoyaltyNonDigitalCouponCardAlV1Component] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DealsGridAlV1Component, [{
        type: Component,
        args: [{ selector: 'deals-grid-al-v1', template: "<div class=\"row\" *ngIf=\"gridSettings.areDigitalCoupons\">\n    <loyalty-card-al-v1 *ngFor=\"let coupon of updatedGridData; let i = index\" [cardType]=\"'coupon'\" [couponDisplayFormat]=\"'grid'\" [cardData]=\"coupon\" [cardIndex]=\"i\" class=\"col-12 col-sm-12 col-md-6 col-lg-{{ 12/gridSettings?.numberOfColumns }} coupon-grid-offer\" (couponToFocusOn)=\"getFocusOn($event)\" [logoProps]=\"logoProps\" [configObj]=\"configObj\"\n    (openRightFlyoutEvent)=\"onClickEvent($event)\"></loyalty-card-al-v1>\n</div>\n<div class=\"row\" *ngIf=\"!gridSettings.areDigitalCoupons\">\n    <loyalty-non-digital-coupon-card-al-v1 *ngFor=\"let coupon of updatedGridData; let i = index\" class=\"col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 pr-0 my-2\" [cmsCardData]=\"coupon\" [cardIndex]=\"i\" (openFlyOutEvent)=\"onClickEvent($event)\" [myListItems]=\"myListItems\"\n    ></loyalty-non-digital-coupon-card-al-v1>\n</div>\n<div class=\"mt-3 d-flex justify-content-center\" *ngIf=\"((updatedGridData && gridData && updatedGridData.length < gridData?.length) || gridSettings?.hasNextPageToken)\">\n    <button aria-label=\"Load More button\" tabindex=\"0\" class=\"btn btn-xl btn-primary\" role=\"button\" (click)=\"loadMoreCoupons();\">{{gridSettings?.buttonText}}</button>\n</div>\n" }]
    }], () => [], { gridSettings: [{
            type: Input
        }], gridData: [{
            type: Input
        }], calledBy: [{
            type: Input
        }], logoProps: [{
            type: Input
        }], myListItems: [{
            type: Input
        }], configObj: [{
            type: Input
        }], openFlyOutEvent: [{
            type: Output
        }], onClickOfLoadMoreEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DealsGridAlV1Component, { className: "DealsGridAlV1Component", filePath: "deals-grid-al-v1/deals-grid-al-v1.component.ts", lineNumber: 9 }); })();

class DealsGridModule {
    static { this.ɵfac = function DealsGridModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DealsGridModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DealsGridModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            LoyaltyCardModule,
            LoyaltyNonDigitalCouponCardModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DealsGridModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DealsGridAlV1Component
                ],
                imports: [
                    CommonModule,
                    LoyaltyCardModule,
                    LoyaltyNonDigitalCouponCardModule
                ],
                exports: [
                    DealsGridAlV1Component
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DealsGridModule, { declarations: [DealsGridAlV1Component], imports: [CommonModule,
        LoyaltyCardModule,
        LoyaltyNonDigitalCouponCardModule], exports: [DealsGridAlV1Component] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DealsGridAlV1Component, DealsGridModule };
